import { createCustomFilterForEntity } from "@shared/backend/create-custom-filter-for-entity";
import {
  filterWithRelationsAndJson,
  type RelationalOrJsonEntityFilter,
} from "@shared/helpers/sql-relations";
import { CallCenterAlert } from "./entity";

const createCustomFilter = createCustomFilterForEntity<CallCenterAlert>();

export class CallCenterAlertFilters {
  static hyperFilter = createCustomFilter<
    RelationalOrJsonEntityFilter<CallCenterAlert>
  >((filters) => {
    return filterWithRelationsAndJson(CallCenterAlert)(filters);
  });
}
